// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_99551c8aa8--buttons--NPc2J"};